import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'

import Select from '../form/Select'

@observer
class SkipQuestionOption extends Component {
    removeOption = (triggers, index) => {
        console.log(`remove option ${index}`)
        const tmp = []
        triggers.forEach((trigger, triggerIndex) => {
            if (triggerIndex !== index) {
                tmp.push(trigger)
            }
        })
        triggers = tmp
    }

    findQuestion(trigger) {
        const { store } = this.props
        const { survey, skipLogicConfig } = store
        const pageQuestions = survey.pages.reduce((questions, page, index) => {
            if (page.pageType === 'ST' && index <= skipLogicConfig.pageIndex) {
                questions = questions.concat(page.questions.slice())
                console.log(page.questions)
            }
            return questions
        }, [])
        console.log('???¬¬¬', skipLogicConfig.pageIndex)
        console.log(JSON.stringify(trigger, null, 4))
        console.log(pageQuestions)
        console.log(R.pathOr('', ['condition', 'pageQuestionId'], trigger))
        console.log(R.pathOr('', ['condition', 'set1'], trigger))
        console.log(R.pathOr('', ['condition', 'set2'], trigger))
        console.log(R.pathOr('', ['condition', 'inheritedPageQuestionId'], trigger))
        let parentQuestion = null
        const pq = pageQuestions.find(pq => pq.id.toLowerCase() === (R.pathOr('', ['condition', 'pageQuestionId'], trigger) ? R.pathOr('', ['condition', 'pageQuestionId'], trigger).toLowerCase() : null))
        this.question = pq ? pq.question : undefined
        if (pq && pq.parentId) {
            parentQuestion = pageQuestions.find(pageQuestion => pageQuestion.id.toLowerCase() === pq.parentId.toLowerCase())
        }
        this.parentQuestion = parentQuestion ? parentQuestion.question : undefined
    }

    getLabel = () => {
        const { store } = this.props
        return this.question
            ? this.question.content.getTitleByLocale('shortTitle', store.surveyLocale, store.survey.metadata.defaultLocale)
            : 'Question not found -- remove'
    }

    getLogicOptions = () => {
        const questionTypeCode = R.pathOr('', ['questionTypeCode'])(this.question)
        let options = [
            {
                label: 'Is one of',
                value: 'OR',
            },
            {
                label: 'Is not one of',
                value: 'NOR',
            },
        ]

        if (questionTypeCode === 'CH') {
            options.push(
                {
                    label: 'Is exactly',
                    value: 'AND',
                },
                {
                    label: 'Is not exactly',
                    value: 'NAND',
                },
            )
        } else if (['I', 'PC'].includes(questionTypeCode)) {
            options = [
                {
                    value: 'Gt',
                    label: 'Is more than',
                },
                {
                    value: 'Eq',
                    label: 'Is equal to',
                },
                {
                    value: 'Lt',
                    label: 'Is less than',
                }
            ]
        } else if (['TX', 'TA', 'TL', 'UV'].includes(questionTypeCode)) {
            options = [
                {
                    value: true,
                    label: 'Is answered',
                },
                {
                    value: false,
                    label: 'Is NOT answered',
                },
            ]
        }

        return options
    }

    getSGOptions = (pageQuestion) => {
        let options = []

        if (pageQuestion.question.optionSetY) {
            options = options.concat(pageQuestion.question.optionSetY.options.slice())
        }

        options = options.concat(pageQuestion.optionSetY.options.slice())
        return {
            options,
        }
    }

    getOptionLabel = (index) => {
        const { question, store, origQuestion } = this.props
        const { surveyLocale, survey } = store
        const { defaultLocale } = survey.metadata
        if (!this.question) {
            console.log('no question')
            return 'invalid option (question) -- remove'
        }
        const { initialLocale } = this.question.metadata
        const isDoubleAxis = this.question.isDoubleAxis()
        const { questionTypeCode } = this.question
        const isSmartGrid = questionTypeCode === 'SG'
        const isText = ['TA', 'TX'].includes(questionTypeCode)
        let pageQuestion

        if (isText) {
            return this.getLabel()
        }

        if (isSmartGrid) {
            pageQuestion = survey.pages.reduce((result, page) => {
                if (page.questions && !result) {
                    result = page.questions.find((q) => {
                        console.log(JSON.stringify(q))
                       return q.questionId === this.question.id
                    })
                    console.log(result)
                }
                return result
            }, undefined)
            console.log(pageQuestion.toJSON())
        }
        console.log(origQuestion)
        const { options } = isSmartGrid
            ? this.getSGOptions(pageQuestion)
            : isDoubleAxis
                ? this.question.optionSetY
                : this.question.optionSet
        const trigger = question.triggers[index]
        console.log(`getting option label ${this.parentQuestion}`)
        if (this.question.settings.frontend) {
            console.log(this.question.settings.frontend.isFlipped)
        }
        let option = options.find(option => option.id.toLowerCase() === trigger.condition.set1.toLowerCase())
        // if (!isDoubleAxis) {
            if (!option && this.parentQuestion) {
                option = this.parentQuestion.optionSet.options.find(option => option.id.toLowerCase() === trigger.condition.set1.toLowerCase())
            }
        // }
        if (!option) {
            return 'invalid option (set1) -- remove'
        }
        let label = option.getTitle(surveyLocale, defaultLocale, initialLocale) //.langs.get(store.surveyLocale).text
        if (trigger.condition.set2) {
            // console.log(JSON.stringify(this.question, null, 4))
            let option2 = this.question.optionSetX.options.find(option => option.id.toLowerCase() === trigger.condition.set2.toLowerCase())
            if (!option2 && this.parentQuestion) {
                option2 = this.parentQuestion.optionSet.options.find(option => option.id.toLowerCase() === trigger.condition.set2.toLowerCase())
            }
            let set2 = 'invalid option (set2) -- remove'
            if (option2) {
                set2 = option2.getTitle(surveyLocale, defaultLocale, initialLocale)
            }
            label = `${label} - ${set2}`
        }
        console.log(label)
        return label
    }

    changeLogicOperator = (obj) => {
        const { question, changeTriggerOperator, triggerIndex, index } = this.props
        const { value } = obj

        console.log('changeLogicOperator', value)
        console.log(JSON.stringify(question, null, 4))
        changeTriggerOperator(triggerIndex, index, value)
    }

    updateResponseExists = (obj) => {
        const { group, triggerIndex } = this.props
        const { condition } = group.triggers[triggerIndex]
        condition.responseExists = obj.value

        console.log(`updateResponseExists ${JSON.stringify(group, null, 4)}`)
    }

    render() {
        const { question, key, index, store } = this.props
        if (!question.triggers) {
            return (
                <div className="skiplogic_page_group">
                    {i18n.t('skipLogicModal.invalid')}
                </div>
            )
        }
        this.findQuestion(question.triggers[0])
        const questionTypeCode = R.pathOr('', ['question', 'questionTypeCode'], this)
        const isText = ['TX', 'TA', 'TL', 'UV'].includes(questionTypeCode)
        // const question_options = question.get("options")
        const options = question.triggers.map((trigger, index) => {
            const id = `skipquestionoption_${key}_${index}`
            console.log(`trigger id -> ${trigger.id}`)
            return (
                <div key={id} className="skip-option-label">
                    {this.getOptionLabel(index)}

                    <i
                        className="fal fa-times-circle deleteicon"
                        onClick={(e) => {
                            question.removeTrigger(index, e)
                            store.handleUnsavedSkipLogicChanges()
                        }} 
                    />
                </div>
            )
        })
        const logicOptions = this.getLogicOptions()
        const triggerOperator = isText
            ? R.pathOr(true, ['triggers', 0, 'condition', 'responseExists'])(question)
            : R.pathOr('OR', ['triggers', 0, 'interTriggerLogicalOperator'])(question)
        const defaultValue = logicOptions.find((o) => o.value === triggerOperator)
        return (
            <div className={`skip-date-option-wrapper ${index === 0 ? 'option-wrapper-border-radius' : ''}`}>
                {!isText && (
                    <Select
                        label={i18n.t('skipLogicModal.pageLogicRuleAnswer')}
                        cssClass="skipLogicDropdown"
                        options={logicOptions}
                        onBlur={this.changeLogicOperator}
                        defaultValue={defaultValue.value}
                    />
                )}
                {isText && (
                    <Select
                        cssClass="skipLogicDropdown"
                        label={i18n.t('skipLogicModal.pageLogicRuleQuestion')}
                        defaultValue={defaultValue.value}
                        onBlur={this.updateResponseExists}
                        options={logicOptions}
                    />
                )}

                <br />

                <div style={{ width: '100%', fontSize: 12 }}>
                    {this.getLabel(question.triggers[0])}
                </div>

                <div className="skip-options-container">
                    {options}
                </div>
            </div>
        )
    }
}

export default SkipQuestionOption
